import styled from 'styled-components';

export default styled.div`
  margin-top: 12px;
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.6);

  b {
    font-weight: 500;
    color: #ff4d4f;
  }

  a:active, a:visited, a:link {
    color: #97b8f6;
    text-decoration: underline;
  }

  a:hover {
    text-decoration: none;
  }

  ul {
    list-style-type: disc;
    margin-left: 20px;
    margin-top: 10px;
  }

  span {
    font-weight: 700;
  }
`;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/components/paragraph.js